// extracted by mini-css-extract-plugin
export var back = "CardImage-module--back--af575";
export var card = "CardImage-module--card--7bf03";
export var container = "CardImage-module--container--26771";
export var emphasized = "CardImage-module--emphasized--9c2b0";
export var face = "CardImage-module--face--c1577";
export var flipped = "CardImage-module--flipped--a6503";